import * as yup from "yup";
import { validationArraySelect, validationConfirmNewPasswordL, validationEmailField, validationNewPassword, validationNotEmpty, validationStringSelect } from "./defaultValidations";

export default yup.object({
  pageName: validationNotEmpty("Page Name"),
  linkToPage: validationNotEmpty("Link to Page"),
  masterCode: validationStringSelect("Master Code"),
  status: validationNotEmpty("Status"),
});